var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"env-item"},[_c('div',{staticClass:"env-item-name"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"env-item-unit"},[_vm._v(_vm._s(_vm.unit))]),_c('div',{staticClass:"env-item-value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }